<template>
	<!-- 有效发明专利查询 -->
  <el-row>
    <div class="queryParamStyle">
      <el-row>
        <el-form :model="queryParams" ref="queryParams" :inline="true" >
          
		  <!-- <el-col :span="12">
		    <el-form-item label="发明名称：" prop="fmName">
		      <el-input style="width: 300px"
		              v-model="queryParams.fmName"
		              placeholder="请输入发明名称"
		              clearable
		              size="small"
		      />
		    </el-form-item>
		  </el-col> -->
          <el-col :span="12">
            <el-form-item label="公告日：" prop="ggDate">
              <el-date-picker
                      style="width: 300px"
                      size="small"
                      v-model="ggDates"
                      @change="changeGgDate"
                      type="daterange"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="请选择开始日期"
                      end-placeholder="请选择截止日期"
                      :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专利权人：" prop="zlqrmc">
              <el-input style="width: 300px"
                      v-model="queryParams.zlqrmc"
                      placeholder="请输入专利权人"
                      clearable
                      size="small"
              />
            </el-form-item>
          </el-col>
		  <el-col :span="15">
		    <el-form-item label="申请号/发明名称：" prop="sqh" label-width="140">
		      <el-input style="width: 400px"
		              v-model="queryParams.sqh"
		              placeholder="请输入申请号或发明名称"
		              clearable
		              size="small"
		      />
		    </el-form-item>
		  </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="getList()" style="margin-right: 20px">检 索</el-button>
              <!--<el-button type="primary" icon="el-icon-refresh" size="mini" @click="getList" style="margin-right: 20px">重 置</el-button>-->
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <el-divider></el-divider>
    <div class="search-table">
      <el-table v-loading="loading" :data="list" tooltip-effect="light" :header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
        <el-table-column label="序号" align="center" type="index" width="50"/>
        <el-table-column label="申请号" align="center" prop="sqh" :show-overflow-tooltip="true"/>
        <el-table-column label="主分类号" align="center" prop="zflh" :show-overflow-tooltip="true"/>
        <el-table-column label="发明名称" align="center" prop="fmmc" :show-overflow-tooltip="true"/>
        <el-table-column label="代理机构名称" align="center" prop="dljgmc" width="120" :show-overflow-tooltip="true"/>
        <el-table-column label="专利权人名称" align="center" prop="zlqrmc" width="120" :show-overflow-tooltip="true"/>
        <el-table-column label="申请日" align="center" prop="sqr">
			<template slot-scope="scope">
				<span>
					{{parseTime(scope.row.sqr,'{y}-{m}-{d}')}}
				</span>
			</template>
		</el-table-column>
        <el-table-column label="公告日" align="center" prop="sqrkr" >
			<template slot-scope="scope">
				<span>
					{{parseTime(scope.row.sqrkr,'{y}-{m}-{d}')}}
				</span>
			</template>
		</el-table-column>
      </el-table>
      <pagination
              v-show="total>0"
              :total="total"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="getList"
      />
    </div>

  </el-row>

</template>
<script>
import { listYxfm10, getYxfm10, delYxfm10, addYxfm10, updateYxfm10, exportYxfm10, importTemplate } from "@/api/zscq/yxfm10";
    
  export default {
    //首页
    name: 'yxfmzlcx',
    data(){
      return {
        // 遮罩层
        loading: false,
        // 总条数
        total: 0,
        list:[],
        queryParams:{
          pageNum:1,
          pageSize:10,
          sqh: undefined,
          ggDate: undefined,
          fmName: undefined,
          zlqrmc: undefined,
          startTime: undefined,
          entTime: undefined,
        },
        ggDates: undefined,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    created() {
		const en = JSON.parse(localStorage.getItem('IndexSearchContent'));
		if (en != undefined && en != "") {
			this.queryParams.sqh = en;
		}
        this.handleQuery();
    },
    methods:{
      getList() {
		this.loading = true;
		listYxfm10(this.queryParams).then(response => {
		    this.list = response.rows;
		    this.total = response.total;
		    this.loading = false;
		});
          localStorage.removeItem("IndexSearchContent");
      },
      /** 搜索按钮操作 */
      handleQuery() {
        this.queryParams.pageNum = 1;
        this.getList();
		this.resetQuery();
      },
	  // 更新时间区间
      changeGgDate(value) {
    /*    if (value == null) {
          this.queryParams.startTime = "";
          this.queryParams.entTime = "";
        }else */
            if(value != undefined && value != '' && value != null) {
            this.queryParams.startTime = value[0]
            this.queryParams.entTime = value[1]
        }
      },
	  /** 重置按钮操作 **/
	  resetQuery() {
	    this.queryParams = {};
	    this.ggDates = undefined;
	  },
    }
  }
</script>
<style scoped>
  .el-form-item{
    margin-bottom: 8px;
  }
  .queryParamStyle{
    padding-top: 10px;
  }
  .el-divider--horizontal{
    display: block;
    height: 1px;
    width: 100%;
    margin: 8px 0;
  }
</style>
